import type { AuthUser } from "../context/AuthContext";
import { isAuthenticatedPublisher } from "./authAccess";

export type PublisherGuestRouteGuardInput = {
  isLoading: boolean;
  user: AuthUser | null;
  /** Guest auth entry being visited; used to divert non-publishers off Publisher Log In. */
  entryPath?: "/sign-in" | "/log-in" | string;
};

export type PublisherGuestRouteGuardDecision =
  | { action: "loading" }
  | { action: "allow" }
  | { action: "redirect"; to: "/publisher-dashboard" | "/sign-in" };

export function evaluatePublisherGuestRouteGuard(
  input: PublisherGuestRouteGuardInput,
): PublisherGuestRouteGuardDecision {
  if (input.isLoading) {
    return { action: "loading" };
  }

  if (isAuthenticatedPublisher(input.user)) {
    return { action: "redirect", to: "/publisher-dashboard" };
  }

  // Authenticated non-publisher on Publisher Log In → Create Publisher Account.
  if (input.user && input.entryPath === "/log-in") {
    return { action: "redirect", to: "/sign-in" };
  }

  return { action: "allow" };
}
